"use client";

import { useFeatureFlagVariantKey } from "@posthog/react";
import { useEffect, useRef } from "react";

type PosthogFeatureFlagExposureTrackerProps = {
  flagKey: string;
};

export const PosthogFeatureFlagExposureTracker = ({
  flagKey,
}: PosthogFeatureFlagExposureTrackerProps) => {
  const hasTrackedRef = useRef(false);
  const variant = useFeatureFlagVariantKey(flagKey);

  useEffect(() => {
    if (hasTrackedRef.current) {
      return;
    }

    if (variant === undefined) {
      return;
    }

    hasTrackedRef.current = true;
  }, [variant]);

  return null;
};
